/**
 * SEO 配置 - models (繁體中文)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - 旗艦級 AI 影片生成 | WeryAI',
        description: 'Google Veo 3.1：旗艦級 AI 影片模型，支援原生音訊、幀控制與高級場景延展。',
        keywords: 'Google Veo 3.1, 旗艦 AI 影片, 影片生成, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 高品質 AI 影片生成 | WeryAI',
        description: 'Google Veo 3 生成高品質、逼真的影片，支援強大的動作一致性與原生音訊。',
        keywords: 'Veo 3, Google Veo, AI 影片創作, 文生影片, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 極速 AI 影片生成 | WeryAI',
        description: '用 Google Veo 3 Fast 快速生成高畫質 AI 影片。支持角色一致性與極速渲染。',
        keywords: 'Veo 3 Fast, 極速 AI 影片, 角色一致性, 文生影片, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 物理模擬級 AI 影片生成 | WeryAI',
        description: '體驗 OpenAI Sora 2，生成符合物理規律的超逼真影片。支持多鏡頭敘事與精準控制。',
        keywords: 'Sora 2, OpenAI Sora, 物理模擬, 逼真 AI 影片, 文生影片, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - 旗艦級原生 AI 影片產生器 | WeryAI',
        description: 'WeryAI Video 1.0：旗艦級原生 AI 影片模型，支援原生多鏡頭敘事、智慧圖生影片與物理級動作模擬。',
        keywords: 'WeryAI Video 1.0, WeryAI 原生模型, AI 影片產生器, 多鏡頭敘事, 圖生影片, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - 工作室級 AI 圖像產生器 | WeryAI',
        description: 'WeryAI Image 2.0：旗艦級 AI 圖像模型，支援卓越的文字渲染、超寫實細節。',
        keywords: 'WeryAI Image 2.0, 工作室級 AI, AI 圖像產生器, 專業 AI 設計, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 圖像產生器 - xAI 超寫實 AI 繪圖 | WeryAI',
        description: '在 WeryAI 體驗 xAI 推出的 Grok-2。基於 Flux.1 架構，呈現驚艷的逼真效果。',
        keywords: 'Grok-2, xAI, Flux.1, 逼真 AI, AI 藝術, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - 頂級 AI 影片產生器 | WeryAI',
        description: 'Kling 2.5 Turbo 提供卓越的運鏡控制與情感表現力。創作電影級 AI 影片的首選。',
        keywords: 'Kling 2.5 Turbo, 可靈 AI, 電影級影片, 運鏡控制, 影片生成, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - 專業 AI 影片編輯與生成 | WeryAI',
        description: 'Runway Gen-4 具備深度提示語理解與風格一致性。在 WeryAI 體驗下一代 AI 影片編輯。',
        keywords: 'Runway Gen-4, Runway AI, 影片產生器, AI 影片編輯, 文生影片, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - 電商與動態 AI 影片 | WeryAI',
        description: 'Hailuo 2.3 專為動態動作與電商廣告優化。提供細膩的面部微表情與物體運動控制。',
        keywords: 'Hailuo 2.3, 海螺 AI, MiniMax, 電商影片, 動態 AI 影片, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI 影片產生器 - 高級動作控制 | WeryAI',
        description: '使用 Hailuo AI 生成高級 AI 影片。具備頂尖的動作模擬與逼真場景渲染能力。',
        keywords: 'Hailuo AI, 海螺 AI, 動作控制, 逼真影片, 影片產生器, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 高清細膩 AI 動畫生成 | WeryAI',
        description: '在 WeryAI 體驗 Pika 2.2，生成清晰、銳利的高清 AI 動畫。非常適合精細角色創作。',
        keywords: 'Pika 2.2, Pika AI, AI 動畫, 高清影片, 影片產生器, WeryAI',
    },
    seedance: {
        title: 'Seedance AI 影片產生器 - 舞蹈與動作創作 | WeryAI',
        description: 'Seedance AI 影片產生器 - 舞蹈與動作創作 on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    wan_ai: {
        title: 'Wan AI 影片產生器 - 阿里高保真大模型 | WeryAI',
        description: 'Wan AI 影片產生器 - 阿里高保真大模型 on WeryAI. Realistic and professional results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - 谷歌 Gemini 3.0 Pro 圖像生成 | WeryAI',
        description: '基於推理驅動的 AI 圖像大模型，支持 4K 超寫實畫質與完美文字排版。免費體驗頂尖 AI 繪圖技術。',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, AI 繪圖, 4K 圖像生成, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash 極速繪圖 | WeryAI',
        description: '由谷歌 DeepMind 開發的極速、高一致性 AI 圖像產生器。支持自然語言編輯與多圖融合。',
        keywords: 'Nano Banana, Gemini 2.5 Flash, 極速繪圖, 角色一致性, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI 圖像產生器 - 頂尖開源繪圖大模型 | WeryAI',
        description: 'FLUX 由原 Stable Diffusion 團隊開發，提供卓越的視覺品質與精準的提示語遵循能力。',
        keywords: 'FLUX, AI 繪圖, 文生圖, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - 專業級 AI 繪圖增強版 | WeryAI',
        description: '體驗 FLUX.1 Pro 與 Max 版本，具備更強的文字渲染與角色一致性。專為設計師打造。',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, 專業繪圖, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - 谷歌高級文字轉圖像擴散模型 | WeryAI',
        description: '生成攝影級、藝術化與抽象派圖像。谷歌 Imagen 4 提供多樣化的風格控制。',
        keywords: 'Imagen 4, 谷歌 AI 繪圖, 擴散模型, 藝術生成, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - 阿里開源文字渲染模型 | WeryAI',
        description: '阿里 Qwen Image 模型專注於多語言文字渲染與風格化創作。免費生成專業級視覺素材。',
        keywords: 'Qwen Image, 通義千問, 阿里 AI 繪圖, 多語言文字, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 圖像生成 - 阿里高保真文生圖大模型 | WeryAI',
        description: 'Wan 2.5 支持精準提示語遵循與攝影級渲染能力。阿里最新高保真 AI 繪圖技術。',
        keywords: 'Wan AI, Wan 2.5, 阿里 AI 繪圖, 高保真圖像, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - 字節跳動批量化 4K 繪圖模型 | WeryAI',
        description: '字節跳動推出的極速繪圖模型，支持批量處理與 4K 高畫質渲染。',
        keywords: 'Seedream, 字節跳動 AI, 批量繪圖, 4K 圖像, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - 字節跳動全能 AI 圖像創作模型 | WeryAI',
        description: 'Dreamina 4.0 支持手繪轉圖像、風格遷移與多角色融合。字節跳動頂尖繪圖模型。',
        keywords: 'Dreamina 4.0, 即夢 AI, 手繪變圖像, 風格遷移, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - 字節跳動旗艦級 AI 圖像生成模型 | WeryAI',
        description: 'Seedream 4.5 是字節跳動最新推出的旗艦級 AI 圖像模型，專注於精準文字渲染與多圖融合，支援4K超清畫質輸出。立即在 WeryAI 免費體驗。',
        keywords: 'Seedream 4.5, AI圖像生成, 文字渲染, 多圖融合, 字節跳動, 4K畫質, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - 全球頂尖藝術審美 AI 繪圖 | WeryAI',
        description: '以極致的光影表現力與藝術美感聞名的 Midjourney 模型。在 WeryAI 一站式使用。',
        keywords: 'Midjourney, AI 藝術, 光影表現, 高級人像, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI 影片生成器 - 創作電影級影片 | WeryAI',
        description: '在 WeryAI 上使用 Runway Gen-4.5 創作驚艷影片。採用自迴歸擴散混合架構，提供精準的物理模擬和時序一致性。',
        keywords: 'Runway Gen-4.5, AI影片生成器, 電影級AI影片, 物理模擬, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI 影片生成器 - 高品質影片創作 | WeryAI',
        description: '在 WeryAI 上使用 Kling 2.6 Pro 生成高品質影片。體驗原生音視訊生成、1080p 電影品質、卓越的提示詞遵循度。',
        keywords: 'Kling 2.6 Pro, AI影片生成器, 高品質AI影片, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 影片生成器 - 精確的攝影機控制和首尾幀指導 | WeryAI',
        description: '在 WeryAI 使用 Dreamina 3.0（即夢 3.0）生成電影級 AI 影片。支援首尾幀精確控制、專業運鏡和 1080p 高動態影片生成。',
        keywords: 'Dreamina 3.0, 即夢3.0, AI影片生成器, 運鏡控制, 首尾幀控制, 字節跳動AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI 影片生成器 - 創意影片生成 | WeryAI',
        description: '在 WeryAI 上釋放您的創造力，使用 Kling O1 AI 影片生成器。非常適合生成充滿想像力和獨特的影片內容。',
        keywords: 'Kling O1, AI影片生成器, 創意AI影片, Kling AI, WeryAI',
    },
}
